// Copyright (c) 2020-2026 Life and Soft

import { GET_ERRORS } from "../actions/types";

const initialState = {};

function errorReducer(state = initialState, action) {
  if (action.type === GET_ERRORS) {
    return { ...action.payload };
  } else return state;
}

export default errorReducer;
